import React from 'react'
import { SiteDataProvider, useSiteData } from '../context/SiteDataContext'
import styled from 'styled-components'
import LoadingSpinner from './LoadingSpinner'

const ErrorMessage = styled.div`
  padding: 2rem;
  margin: 2rem;
  background-color: #fff3f3;
  border: 1px solid #ffcdd2;
  border-radius: 4px;
  color: #d32f2f;
`

const RootContent = ({ children }) => {
  const { error, loading } = useSiteData()
  
  if (loading) {
    return <LoadingSpinner />
  }
  
  return (
    <>
      {error && (
        <ErrorMessage>
          <h2>Error loading data</h2>
          <p>{error}</p>
          <p>Please check your internet connection and try again.</p>
        </ErrorMessage>
      )}
      {children}
    </>
  )
}

const Root = ({ children }) => {
  return (
    <SiteDataProvider>
      <RootContent>{children}</RootContent>
    </SiteDataProvider>
  )
}

export default Root 